import { EDITORIAL_HUB_FAMILIES } from "@/features/editorial-hub/editorial-hub-families";
import { getFeaturePageLandingQueryOptions } from "@/features/feature-page-landing/feature-page-landing-query";
const SplitLoader = async ({
  context: {
    queryClient,
    locale
  }
}) => {
  const landings = await Promise.all(EDITORIAL_HUB_FAMILIES.map(family => queryClient.ensureQueryData(getFeaturePageLandingQueryOptions({
    family,
    locale
  }))));
  return {
    locale,
    landings
  };
};
export { SplitLoader as loader };